import { ApiSync, ApiSyncType } from "@incendium/api";
import { syncService } from "Apis";

export const triggerWooCommerceSync = async (projectId: number) => {
  await syncService.syncServiceTriggerWooCommerceSync({
    projectId,
  });
};

export const fetchWooCommerceSync = async (
  projectId: number,
): Promise<ApiSync | undefined> => {
  const res = await syncService.syncServiceListSyncs({ projectId });
  return res.results?.find((s) => s.type === ApiSyncType.WOOCOMMERCE_CONNECTOR);
};
